import axios from '../axios'
// 异常处理记录
export const getAll  = (data) => {
    return axios.axioseRquest({
        url: '/api/News/GetAll',
        method: 'get',
        params: data
    })
}

export const getDetail = (data) => {
    return axios.axioseRquest({
        url:'/api/News/'+data,
        method:'get',
    })
}